module.exports = __webpack_public_path__ + "static/media/info-popup.52c0e165.png";